import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useTutorial } from '../TutorialProvider';
import { useStyles } from './styles';

/**
 * Renders a small control while a guided tutorial is running, letting the
 * user bail out of it at any point. Hidden until the first step's narration
 * has actually started, so it doesn't appear during the brief gap between
 * starting the tutorial and its first audio attempt resolving.
 */
const TutorialRunningControls = () => {
  const { t: translate } = useTranslation();
  const classes = useStyles();
  const { isTutorialRunning, hasNarrationStarted, stopTutorial } =
    useTutorial();

  if (!isTutorialRunning || !hasNarrationStarted) {
    return null;
  }

  return (
    <Button
      onClick={stopTutorial}
      sx={classes.root}
      data-testid="tutorial-running-skip-btn"
    >
      {translate('guidedTutorial.skipRunning')}
    </Button>
  );
};

export default TutorialRunningControls;
